import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "side-menu-inner-item__txt" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 0,
  class: "side-menu-inner-item__contents"
}

import { ref, withDefaults } from "vue";
import {
  mapModifires,
  type typeModifires,
  mergeModifires,
} from "@/components/utils/modifires";

interface Props {
  modifires?: typeModifires;
  text?: string;
  opend?: boolean;
  disabled?: boolean;
  allSelectButton?: boolean;
  alone?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'side-menu-inner-item',
  props: {
    modifires: { type: [String, Array, Boolean] },
    text: {},
    opend: { type: Boolean, default: false },
    disabled: { type: Boolean },
    allSelectButton: { type: Boolean },
    alone: { type: Boolean }
  },
  emits: ["selectAll", "resetAll"],
  setup(__props: any, { emit }) {

const props = __props;




const isOpend = ref<boolean>(props.opend);

const componentClass = () =>
  mapModifires(
    "side-menu-inner-item",
    mergeModifires(props.modifires, isOpend.value && "opend")
  );

const toggle = () => {
  isOpend.value = !isOpend.value;
};

const selectAll = () => {
  emit("selectAll");
};

const resetAll = () => {
  emit("resetAll");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(componentClass())
  }, [
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        class: _normalizeClass(["side-menu-inner-item__btn", { 'side-menu-inner-item__btn_alone': _ctx.alone }]),
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (toggle()), ["self"]))
      }, [
        _createElementVNode("span", _hoisted_1, [
          _renderSlot(_ctx.$slots, "text"),
          (_ctx.allSelectButton)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "all-select-button",
                disabled: _ctx.disabled,
                onClick: selectAll
              }, " 全選択 ", 8, _hoisted_2))
            : _createCommentVNode("", true),
          (_ctx.allSelectButton)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "all-select-button",
                disabled: _ctx.disabled,
                onClick: resetAll
              }, " 全解除 ", 8, _hoisted_3))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ]),
    (_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})